import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export enum EvaluationType {
  Accuracy = 'ACCURACY',
  SemanticSimilarity = 'SEMANTIC_SIMILARITY',
  Faithfulness = 'FAITHFULNESS',
}

export const EvaluationBlockConfigSchema = z.object({
  output: z.string().min(1, { message: 'Generated value is required' }),
  reference: z.string().min(1, { message: 'Source value is required' }),
  evaluationType: z.enum(EvaluationType, {
    message: 'Evaluation type is required',
  }),
});

export type EvaluationBlockConfig = z.infer<typeof EvaluationBlockConfigSchema>;

export const EvaluationBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Evaluation),
  config: EvaluationBlockConfigSchema,
});

export type EvaluationBlock = z.infer<typeof EvaluationBlockSchema>;
